<script>
import InflectionSchemeLink from "@/components/article/InflectionSchemeLink.vue";
import showInflectionSchemeButtonMixin from "@/components/mixins/article/dictsys/show-inflection-scheme-button";
import lang from "@/directives/lang";

import ArticleContentMetadata from "./ArticleContentMetadata.vue";
import Examples from "./Examples.vue";
import Inflections from "./Inflections.vue";

export default {
  name: "ArticleContentCombinations",
  components: {
    ArticleContentMetadata,
    Examples,
    Inflections,
    InflectionSchemeLink
  },
  directives: {
    lang
  },
  mixins: [showInflectionSchemeButtonMixin],
  props: {
    articleId: {
      type: String,
      required: true
    },
    combinations: {
      type: Array,
      required: true
    }
  }
};
</script>

<template>
  <div class="indentation-container">
    <div v-for="(combination, index) in combinations" :key="index">
      <span class="article-list-bullet article-list-bullet--prominent">{{ index + 1 }}.</span>

      <span v-lang:source class="article-content__text article-content__text--prominent">{{
        combination.combination
      }}</span>
      <i
        v-if="combination.metadata.categories.length > 0"
        v-lang:da
        class="article-content__text article-content__text--muted ml-1"
        >({{ combination.metadata.categories.join(", ") }})</i
      >
      <i
        v-if="combination.metadata.usages.length > 0"
        v-lang:da
        class="article-content__text article-content__text--muted ml-1"
        >({{ combination.metadata.usages.join(", ") }})</i
      >
      <i
        v-if="combination.explanation"
        v-lang:da
        class="article-content__text article-content__text--muted ml-1"
        >({{ combination.explanation }})</i
      >

      <span class="article-content__translation-separator">&raquo;</span>

      <i
        v-if="combination.metadata.varieties.length > 0"
        v-lang:da
        class="article-content__text article-content__text--muted mr-1"
        >({{ combination.metadata.varieties.join(", ") }})</i
      >
      <span
        v-lang:target
        class="article-content__text article-content__text--primary article-content__text--prominent"
        >{{ combination.translation }}</span
      >
      <InflectionSchemeLink
        v-if="showInflectionSchemeButton(combination)"
        :word="combination.translation"
        :article-id="articleId"
        :translation-id="combination.inflectionScheme.id"
        :section-id="`${index}`"
      />
      <Inflections
        v-else
        :inflections="combination.inflections.long"
        lang="target"
        class="article-content__inflections ml-2"
      />
      <span class="ml-2"></span>
      <ArticleContentMetadata :dictsys-article="combination" />

      <Examples :examples="combination.examples" />
    </div>
  </div>
</template>
